var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHydrowandInfusion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#EBD5C6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_977_9194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.32 21.99L25.88 13.81C25.7158 13.5625 25.4929 13.3594 25.2312 13.219C24.9695 13.0785 24.677 13.005 24.38 13.005C24.083 13.005 23.7905 13.0785 23.5288 13.219C23.2671 13.3594 23.0442 13.5625 22.88 13.81L17.46 21.99C13.88 27.28 17.2 34.7 23.57 35.25C23.84 35.25 24.11 35.25 24.39 35.25C24.67 35.25 24.94 35.25 25.21 35.25C31.58 34.7 34.88 27.28 31.32 21.99ZM23.88 33.5C22.8225 33.4312 21.7968 33.1102 20.8887 32.5639C19.9805 32.0177 19.2164 31.262 18.66 30.36C18.5966 30.2488 18.5782 30.1175 18.6087 29.9932C18.6392 29.8688 18.7162 29.7609 18.8239 29.6917C18.9316 29.6224 19.0618 29.5972 19.1875 29.621C19.3133 29.6449 19.4252 29.7161 19.5 29.82C19.9751 30.5884 20.6267 31.2324 21.4007 31.6985C22.1746 32.1646 23.0486 32.4394 23.95 32.5C24.0157 32.5038 24.08 32.5206 24.1392 32.5493C24.1984 32.5781 24.2514 32.6182 24.295 32.6674C24.3387 32.7167 24.3722 32.774 24.3937 32.8363C24.4151 32.8985 24.4241 32.9643 24.42 33.03C24.4097 33.1636 24.3474 33.2877 24.2463 33.3757C24.1453 33.4636 24.0137 33.5083 23.88 33.5Z",
    fill: "#B0654D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_977_9194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.77,
    height: 22.28,
    fill: "white",
    transform: "translate(16 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHydrowandInfusion);
export default __webpack_public_path__ + "static/media/hydrowand-infusion.21d8aad0dc10d6027ddb7cebebc5622d.svg";
export { ForwardRef as ReactComponent };